import { Box, makeStyles, Typography } from "@material-ui/core";
import { FiberManualRecord } from "@material-ui/icons";
import clsx from "clsx";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { setOpenNotify } from "src/redux/account-slice";
import { timeHasPassed } from "src/utils";
import battleHandImg from "./assets/battle_hand.png";

const useStyles = makeStyles(() => ({
  wp: {
    height: "86px",
    borderBottom: "1px solid rgba(255,255,255,0.25)",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  wpImg: {
    height: "100%",
    "& img": {
      width: 70,
      marginTop: 25,
      objectFit: "contain",
    },
  },
  info: {
    display: "flex",
    flexDirection: "column",
    margin: "10px 8px",
    flexGrow: 1,
  },
  timestamp: {
    margin: "1px 0",
    fontSize: "12px",
    color: "#4d83b9",
  },
  successWp: {
    width: 65,
    marginTop: 25,
    color: "#F48C24",
    fontSize: "12px",
    "& .MuiSvgIcon-root": {
      verticalAlign: "-2px",
      fontSize: "12px",
    },
  },
  lastRecord: {
    border: "none",
  },
}));

export default function BattleHandNotify({ item, isLastRecord }) {
  const cls = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();

  function renderTimestamp(timestamp) {
    return timeHasPassed(timestamp);
  }

  return (
    <Box
      onClick={() => {
        history.push(`/battle-hand/${item.roomId}`);
        dispatch(setOpenNotify(false));
      }}
      className={clsx(cls.wp, { [cls.lastRecord]: isLastRecord })}
      key={item.collectionId}
    >
      <Box m={1} className={cls.wpImg}>
        <img src={battleHandImg} />
      </Box>
      <Box className={cls.info}>
        <Typography style={{ color: "#888e98", fontSize: "14px", fontWeight: 600, margin: "1px 0" }}>
          ID Room: <span style={{ color: "white" }}>0{item.roomId}</span>
        </Typography>
        <Typography className={cls.timestamp}>Joining time: {renderTimestamp(item.joiningTime * 1000)}</Typography>
      </Box>
      <Box my={"10px"} mr={"10px"} alignSelf={"start"} className={cls.successWp}>
        <FiberManualRecord />
        Confirm
      </Box>
    </Box>
  );
}
